import gql from 'graphql-tag'

export const GET_CNC_LINKS = gql`
  query {
    getCncLinks {
      title
      link
    }
  }
`
